var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"society-table-container my-3"},[_c('h5',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.questionName))]),_c('b-table-lite',{staticClass:"m-0",attrs:{"items":_vm.societies,"fields":_vm.societyFields,"small":"","striped":"","hover":"","responsive":"","outlined":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }